<template>
    <!-- :style="`background-image: url(${bgImage});`" -->
    <div class="fivepoint-colorcard-container" :class="`item-container-${index}`">
        <div :class="`item-text-${index}`" class="fivepoint-colorcard-text" v-html="$t(data.colorCardText[index])" />
        <div class="fivepoint-colorcard-link">
            <a @click="handleClick(index)">
                <CommonComponentsButtonLine borderless :button-text="data.linkButtonText" />
            </a>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import contactUs from '@assets/imgs/AboutUs/Introduction/FivePoint/contactUs.jpg';
    import contactUsMobile from '@assets/imgs/AboutUs/Introduction/FivePoint/contactUsMobile.jpg';

    import fellowship from '@assets/imgs/AboutUs/Introduction/FivePoint/fellowship.jpg';
    import fellowshipMobile from '@assets/imgs/AboutUs/Introduction/FivePoint/fellowshipMobile.png';
    import { matchMobile } from '~~/composables/useMatchRules.ts';

    import i18n from '@/locales';
    const { t } = i18n.global;

    defineProps<{
        index: number;
    }>();

    const data = reactive({
        linkButtonText: t('global_link_button_0'),
        colorCardText: [
            'global_aboutus_introduction_fivepoint_colorcard_title',
            'global_aboutus_introduction_fivepoint_colorcard_title1',
        ],
        to: ['https://app.mokahr.com/social-recruitment/linctex/46055#/', routeMapper.aboutus.fellowship],
        contactUs,
        fellowship,
        contactUsMobile,
        fellowshipMobile,
    });

    const handleClick = (index: number) => {
        pushRouter(data.to[index]);
    };
    // const bgImage = computed(() => (props.index === 0 ? data.contactUs : data.fellowship));
    // const bgImageMobile = computed(() => (props.index === 0 ? data.contactUsMobile : data.fellowshipMobile));

    onMounted(() => {
        const ifMatched = matchMobile();
        const bg1 = document.querySelector('.item-container-0') as HTMLElement;
        const bg2 = document.querySelector('.item-container-1') as HTMLElement;
        if (!ifMatched) {
            bg1.style.backgroundImage = `url(${data.contactUs})`;
            bg2.style.backgroundImage = `url(${data.fellowship})`;
        } else {
            bg1.style.backgroundImage = `url(${data.contactUsMobile})`;
            bg2.style.backgroundImage = `url(${data.fellowshipMobile})`;
        }
    });
</script>

<style lang="less" scoped>
    .fivepoint-colorcard-container {
        margin-top: .convert(60px) [ @vw];
        border-radius: 20px;
        height: .convert(600px) [ @vw];
        background-size: cover;
        background-repeat: no-repeat;

        text-align: center;
        position: relative;
        overflow: hidden;
        @media (max-width: @screen-mobile-width) {
            height: .convert(540px) [ @vw-mobile] !important;
            margin-top: 0;
        }
        .fivepoint-colorcard-text {
            position: absolute;
            font-size: .convert(@font-size-title-lg) [ @vw]; //64px
            line-height: normal;
            bottom: .convert(120px) [ @vw];
            left: 50%;
            transform: translate(-50%, 0);
            @media (max-width: @screen-mobile-width) {
                font-size: .convert(32px) [ @vw-mobile];
                bottom: .convert(76px) [ @vw-mobile];
                margin: 0 auto;
            }
        }
        .fivepoint-colorcard-link {
            text-align: center;
            position: absolute;
            bottom: .convert(40px) [ @vw];
            left: 50%;
            transform: translateX(-50%);
            @media (max-width: @screen-mobile-width) {
                // height: .convert(540px) [ @vw-mobile] !important;
                bottom: .convert(20px) [ @vw-mobile];
            }
        }
    }
    .item-container-0 {
        height: .convert(660px) [ @vw];
    }
</style>
